import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import FasTagPricing from "./FasTagPricing";
import {
  submitFastagPricing,
  transferTagRequest,
  fetchUserDetailsById,
  addCashbackForFastag,
  deleteCashbackForFastag,
  reAssignUserForFastag
} from "services/redux/fasTag/action";
import { documentUploadUrlPublic } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
  fastagPricingResponse: state.fastagPricingReducer.fastagPricingResponse,
  fetchUserDetailsByIdResponse: state.fastagPricingReducer.fetchUserDetailsByIdResponse,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      submitFastagPricing,
      documentUploadUrlPublic,
      transferTagRequest,
      fetchUserDetailsById,
      addCashbackForFastag,
      deleteCashbackForFastag,
      reAssignUserForFastag
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(FasTagPricing);
